import { useEffect, useState } from "react";
import { Download, LogOut, Mail, Phone, Wallet } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { RoleBadge } from "@/components/Badges";
import { MyAttendance } from "@/components/MyAttendance";
import { useAuth } from "@/context/AuthContext";
import { api, inr, MONTHS, DEPT, downloadFile, formatErr } from "@/lib/api";

export default function Profile() {
  const { user, logout } = useAuth();
  const [slips, setSlips] = useState([]);

  useEffect(() => {
    api.get("/payroll/my").then((r) => setSlips(r.data));
  }, []);

  const dl = (s) =>
    downloadFile(`/payroll/${s.id}/payslip`, `Upkar_Payslip_${s.pay_period_year}_${s.pay_period_month}.pdf`).catch((e) => toast.error(formatErr(e)));

  return (
    <div className="space-y-6">
      <div className="bg-slate-900 text-white rounded-2xl p-6 relative overflow-hidden grain">
        <div className="relative flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-sky-600 grid place-items-center font-heading text-2xl font-extrabold">{user.full_name[0]}</div>
          <div>
            <div className="font-heading text-2xl font-extrabold" data-testid="profile-name">{user.full_name}</div>
            <div className="flex items-center gap-2 mt-1"><RoleBadge role={user.role} /><span className="text-xs text-slate-400">{DEPT[user.department]}</span></div>
          </div>
        </div>
        <div className="relative mt-5 space-y-1.5 text-sm text-slate-300">
          <div className="flex items-center gap-2"><Mail className="h-4 w-4" />{user.email}</div>
          <div className="flex items-center gap-2"><Phone className="h-4 w-4" />{user.phone_number}</div>
        </div>
      </div>
      <MyAttendance />
      <section>
        <h2 className="font-heading text-lg font-bold text-slate-900 mb-3 flex items-center gap-2"><Wallet className="h-4 w-4 text-sky-600" />Payslips</h2>
        <div className="space-y-2" data-testid="payslip-list">
          {slips.length === 0 && <div className="text-sm text-slate-500 text-center p-6 border border-dashed rounded-xl bg-white">No approved payslips yet.</div>}
          {slips.map((s) => (
            <div key={s.id} className="bg-white border rounded-xl p-4 flex items-center justify-between" data-testid={`payslip-row-${s.id}`}>
              <div>
                <div className="font-semibold text-slate-900">{MONTHS[s.pay_period_month - 1]} {s.pay_period_year}</div>
                <div className="text-xs text-slate-500">{s.days_worked} days worked · {s.approval_status}</div>
              </div>
              <div className="flex items-center gap-3">
                <div className="font-mono-num font-semibold">{inr(s.final_payout)}</div>
                <Button size="icon" variant="outline" onClick={() => dl(s)} data-testid={`payslip-download-${s.id}`}><Download className="h-4 w-4" /></Button>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Button variant="outline" onClick={logout} className="w-full h-11 text-rose-600 border-rose-200 hover:bg-rose-50" data-testid="staff-logout-button"><LogOut className="h-4 w-4 mr-2" />Log out</Button>
    </div>
  );
}
